import {
  AnrokIntegrationSettingsSchema,
  type AnrokDefaultTaxMethod,
  INTEGRATION_TYPES_V3,
} from '@vy/integrations-types';
import { useIntegrationSettings } from './use-integration-settings';

export function useAnrokDefaultTaxMethod(): AnrokDefaultTaxMethod | undefined {
  const { data: anrokSettings } = useIntegrationSettings(INTEGRATION_TYPES_V3.ANROK);

  if (!anrokSettings) {
    return undefined;
  }

  const parsed = AnrokIntegrationSettingsSchema.parse(anrokSettings.integrationSettings);

  return parsed.integrationConfiguration.generalConfig.defaultTaxMethod;
}
